import TextField from 'client/widget-components/components/TextField';
import { Customization } from 'client/widget-components/ecom/stores/types';
import React, { FC, memo } from 'react';
import {
    CUSTOMIZATIONS_DATA_GRABS,
    MAX_TEXT_FIELD_LENGTH,
} from '../../constants';
import { ProductCustomizationsStyles } from '../../types';
import CustomizationFieldError from '../CustomizationFieldError';
import TextFieldCustomizationLabel from './TextFieldCustomizationLabel';
import TextFieldCustomizationTextArea from './TextFieldCustomizationTextArea';

interface TextFieldCustomizationProps extends Customization {
    value?: string;
    error?: string | null;
    styles?: ProductCustomizationsStyles;
    maxLength?: number;
    onChange: (fieldId: string, value: string) => void;
    validateField: (fieldId: string) => void;
}

const TextFieldCustomization: FC<TextFieldCustomizationProps> = ({
    id,
    label,
    hint,
    title,
    value = '',
    mandatory = false,
    maxLength = MAX_TEXT_FIELD_LENGTH,
    styles,
    error,
    onChange,
    validateField,
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange(id, event.target.value);
    };

    const handleBlur = () => {
        validateField(id);
    };

    return (
        <TextField
            label={label}
            placeholder={hint}
            error={error}
            styles={{
                label: styles?.inputLabel,
                counter: styles?.inputCharacterCounter,
            }}
            dataAuto='product-customizations-text-field'
            dataGrabs={CUSTOMIZATIONS_DATA_GRABS}
            labelElement={
                <TextFieldCustomizationLabel
                    styles={{
                        inputLabel: styles?.inputLabel,
                        inputCharacterCounter: styles?.inputCharacterCounter,
                    }}
                    required={mandatory}
                    label={label}
                    valueLength={value.length}
                    maxLength={maxLength}
                />
            }
            textareaElement={
                <TextFieldCustomizationTextArea
                    name={title}
                    id={id}
                    value={value}
                    placeholder={hint}
                    required={mandatory}
                    maxLength={maxLength}
                    error={!!error}
                    onBlur={handleBlur}
                    styles={{
                        textArea: styles?.input,
                        placeholder: styles?.inputPlaceholder,
                    }}
                    data-grab={CUSTOMIZATIONS_DATA_GRABS?.textAreaDataGrab}
                    increaseSpecificity
                    onChange={handleChange}
                />
            }
            fieldErrorElement={
                !!error && <CustomizationFieldError error={error} />
            }
        />
    );
};

export default memo(TextFieldCustomization);
